export default __webpack_public_path__ + "static/media/long-contact-1.5047ae1e.jpg";